import {ServicesModule} from 'services/module';
import {AlgorithmService} from 'services/algorithmService';
import {AvailabilityService} from 'services/availabilityService';
import {ExifService} from 'services/exifService';
import {RegistrationService} from 'services/registrationService';
import {TimezonesService} from 'services/timezonesService';
import {VisitorService} from 'services/visitorService';
import {GroupService} from './groupService';
import {CustomInputService} from 'services/customInputService';

export default ServicesModule.
    service('RegistrationService', RegistrationService).
    service('AlgorithmService', AlgorithmService).
    service('TimezonesService', TimezonesService).
    service('VisitorService', VisitorService).
    service('AvailabilityService', AvailabilityService).
    service('ExifService', ExifService).
    service('GroupService', GroupService).
    service('CustomInputService', CustomInputService);
